import { render } from "./ChatMessage.vue?vue&type=template&id=1651d16e&scoped=true&ts=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=1651d16e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1651d16e"]])

export default __exports__